import LineInterface from 'app/interfaces/LineInterface';
import NestedLineInterface from 'admin/interfaces/NestedLineInterface';

export const isHandicapLine = (line: LineInterface | NestedLineInterface): boolean => isHandicap(line.type);

export const isHandicap = (type: string): boolean => type === 'Handicap';
